import { createSlice } from '@reduxjs/toolkit';
import FineTuningState from '../../../constants/FineTuning/initialstates/FineTuningState';
const fineTuningSlice = createSlice({
  name: 'fineTuning',
  initialState: FineTuningState,
  reducers: {
    setFineTuningData: (state, action) => {
      state.data = action.payload;
    },
    setFineTuningEtc: (state, action) => {
      state.etc = action.payload;
    },
    setActiveTab: (state, action) => {
      state.etc.activeTab = action.payload;
    },
  },
});

export const { setFineTuningData, setFineTuningEtc, setActiveTab } = fineTuningSlice.actions;

export default fineTuningSlice.reducer;
